"use strict";

var e = require("react/jsx-runtime"),
  s = require("react"),
  t = function () {
    return (t = Object.assign || function (e) {
      for (var s, t = 1, i = arguments.length; t < i; t++) for (var a in s = arguments[t]) Object.prototype.hasOwnProperty.call(s, a) && (e[a] = s[a]);
      return e;
    }).apply(this, arguments);
  };
function i() {
  return e.jsx("svg", t({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "55",
    height: "55"
  }, {
    children: e.jsx("path", {
      d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
    }, void 0)
  }), void 0);
}
function a() {
  return e.jsx("svg", t({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "45",
    height: "45"
  }, {
    children: e.jsx("path", {
      d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    }, void 0)
  }), void 0);
}
function o() {
  return e.jsx("svg", t({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, {
    children: e.jsx("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }, void 0)
  }), void 0);
}
function l() {
  return e.jsx("svg", t({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "35",
    height: "35"
  }, {
    children: e.jsx("path", {
      d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
    }, void 0)
  }), void 0);
}
var d = "styles-module_floatingWhatsapp__1akvz",
  n = "styles-module_whatsappButton__IWx9V",
  c = "styles-module_whatsappChatBox__P75uz",
  r = "styles-module_open__2W1cE",
  u = "styles-module_close__2I1sI",
  v = "styles-module_chatHeader__23UA6",
  h = "styles-module_avatar__17BL2",
  m = "styles-module_status__3GBr2",
  _ = "styles-module_statusTitle__1svrc",
  p = "styles-module_statusSubtitle__34Bli",
  x = "styles-module_chatBody__3SG9H",
  f = "styles-module_dark__3QbTe",
  j = "styles-module_message__2RbY_",
  y = "styles-module_accountName__2jFCW",
  w = "styles-module_messageBody__1hzTp",
  g = "styles-module_triangle__23s3K",
  N = "styles-module_messageTime__1IoCp",
  b = "styles-module_chatFooter__1yhZR",
  k = "styles-module_input__2IYfc",
  B = "styles-module_buttonSend__3FZcz",
  z = "styles-module_arabic__1R26X",
  C = new Date().toTimeString().split(":").slice(0, 2).join(":");
module.exports = function (E) {
  var F,
    L = E.phoneNumber,
    M = void 0 === L ? "1234567890" : L,
    H = E.accountName,
    S = void 0 === H ? "Account Name" : H,
    T = E.avatar,
    A = void 0 === T ? "" : T,
    D = E.statusMessage,
    I = void 0 === D ? "Typically replies within 1 hour" : D,
    V = E.chatMessage,
    W = void 0 === V ? "Hello there! 🤝 \nHow can we help?" : V,
    O = E.darkMode,
    P = void 0 !== O && O,
    R = E.allowClickAway,
    q = void 0 !== R && R,
    G = E.allowEsc,
    Y = void 0 !== G && G,
    Z = E.styles,
    K = void 0 === Z ? {} : Z,
    Q = E.className,
    U = void 0 === Q ? "" : Q,
    X = E.placeholder,
    J = void 0 === X ? "Type a message.." : X,
    $ = s.useState(!1),
    ee = $[0],
    se = $[1],
    te = s.useState(""),
    ie = te[0],
    ae = te[1],
    oe = function () {
      return se(function (e) {
        return !e;
      });
    },
    le = s.useCallback(function () {
      q && ee && se(!1);
    }, [q, ee]),
    de = s.useCallback(function (e) {
      Y && "Escape" === e.key && ee && se(!1);
    }, [Y, ee]);
  return s.useEffect(function () {
    return document.addEventListener("click", le, !1), function () {
      return document.removeEventListener("click", le);
    };
  }, [le]), s.useEffect(function () {
    return document.addEventListener("keydown", de, !1), function () {
      return document.removeEventListener("keydown", de);
    };
  }, [de]), e.jsxs("div", t({
    className: d + " " + (P ? f : "") + " " + U
  }, {
    children: [e.jsx("div", t({
      className: n,
      onClick: oe,
      style: K,
      "aria-hidden": "true"
    }, {
      children: e.jsx(i, {}, void 0)
    }), void 0), e.jsxs("div", t({
      className: c + " " + (ee ? r : u),
      onClick: function (e) {
        return e.stopPropagation();
      },
      "aria-hidden": "true"
    }, {
      children: [e.jsxs("header", t({
        className: v
      }, {
        children: [e.jsx("div", t({
          className: h
        }, {
          children: A ? e.jsx("img", {
            src: A,
            width: "45",
            height: "45",
            alt: "whatsapp-avatar"
          }, void 0) : e.jsx(a, {}, void 0)
        }), void 0), e.jsxs("div", t({
          className: m
        }, {
          children: [e.jsx("span", t({
            className: _
          }, {
            children: S
          }), void 0), e.jsx("span", t({
            className: p
          }, {
            children: I
          }), void 0)]
        }), void 0), e.jsx("div", t({
          className: u,
          onClick: oe,
          "aria-hidden": "true"
        }, {
          children: e.jsx(o, {}, void 0)
        }), void 0)]
      }), void 0), e.jsx("div", t({
        className: x
      }, {
        children: e.jsxs("div", t({
          className: j
        }, {
          children: [e.jsx("span", {
            className: g
          }, void 0), e.jsx("span", t({
            className: y
          }, {
            children: S
          }), void 0), e.jsx("p", t({
            className: w
          }, {
            children: W
          }), void 0), e.jsx("span", t({
            className: N
          }, {
            children: C
          }), void 0)]
        }), void 0)
      }), void 0), e.jsx("footer", t({
        className: b
      }, {
        children: e.jsxs("form", t({
          onSubmit: function (e) {
            e.preventDefault(), ie && (window.open("https://api.whatsapp.com/send/?phone=" + M + "&text=" + ie), ae(""));
          }
        }, {
          children: [e.jsx("input", {
            className: k + " " + (F = ie, /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(F) ? z : ""),
            placeholder: J,
            onChange: function (e) {
              return ae(e.target.value);
            },
            value: ie,
            dir: "auto"
          }, void 0), e.jsx("button", t({
            type: "submit",
            className: B,
            disabled: "" === ie
          }, {
            children: e.jsx(l, {}, void 0)
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
};